var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0129395 8.74313L4.12725 5.14307L12.3559 5.65737L12.8701 13.8861L9.27013 18.0004C9.27013 18.0004 9.27065 14.9152 6.1844 11.8289C3.09816 8.74262 0.0129395 8.74313 0.0129395 8.74313Z",
    fill: "#A0041E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00326e-05 17.9986C1.00326e-05 17.9986 -0.0185043 13.895 1.53516 12.3414C3.08883 10.7877 7.21393 10.8946 7.21393 10.8946C7.21393 10.8946 7.21342 14.9128 5.67055 16.4557C4.12769 17.9986 1.00326e-05 17.9986 1.00326e-05 17.9986Z",
    fill: "#FFAC33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12673 15.9428C5.26287 15.9428 6.18389 15.0218 6.18389 13.8856C6.18389 12.7495 5.26287 11.8284 4.12673 11.8284C2.9906 11.8284 2.06958 12.7495 2.06958 13.8856C2.06958 15.0218 2.9906 15.9428 4.12673 15.9428Z",
    fill: "#FFCC4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.014 0C18.014 0 12.8711 0 6.69966 5.14294C3.61393 7.71441 3.61393 12.3431 4.64251 13.3716C5.67109 14.4002 10.2997 14.4002 12.8711 11.3145C18.014 5.14294 18.014 0 18.014 0Z",
    fill: "#55ACEE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3845 2.572C12.5498 2.572 11.8349 3.07138 11.512 3.78573C11.7701 3.66899 12.0545 3.60059 12.3559 3.60059C13.492 3.60059 14.4131 4.52169 14.4131 5.65776C14.4131 5.95914 14.3447 6.24354 14.2284 6.50121C14.9428 6.17874 15.4416 5.46387 15.4416 4.62917C15.4416 3.4931 14.5206 2.572 13.3845 2.572Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.61377 14.4006C3.61377 14.4006 3.61377 12.3435 4.12806 11.8292C4.64235 11.3149 10.8143 6.17245 11.3281 6.68623C11.8419 7.20001 6.69899 13.3721 6.1847 13.8863C5.67041 14.4006 3.61377 14.4006 3.61377 14.4006Z",
    fill: "#A0041E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.9a38d21ab06331edff088b0a1ef48bc5.svg";
export { ForwardRef as ReactComponent };